import React, { useRef } from 'react';
import { AriaTabProps, useTab } from '@react-aria/tabs';
import { TabListState } from '@react-stately/tabs';
import { Node } from '@react-types/shared';
import { SapphireStyleProps } from '../../../utils';
import { ButtonTabBase } from './ButtonTabBase';
import { TabsSize } from '../TabsProps';
import {
  AriaLabelingPropsKeys,
  GlobalDomAttributes,
} from '../../../utils/types';

interface ButtonTabProps<T>
  extends GlobalDomAttributes,
    SapphireStyleProps,
    Pick<AriaTabProps, AriaLabelingPropsKeys> {
  item: Node<T>;
  size: TabsSize;
  state: TabListState<object>;
}

export function ButtonTab<T>({
  item: { index, key, rendered },
  size,
  state,
}: ButtonTabProps<T>): JSX.Element {
  const ref = useRef<HTMLDivElement | HTMLAnchorElement>(null);
  const { tabProps, isDisabled } = useTab({ key }, state, ref);

  const isActive = state.selectedItem?.index === index;
  return (
    <ButtonTabBase
      {...tabProps}
      size={size}
      isActive={isActive}
      isDisabled={isDisabled}
      ref={ref}
    >
      {rendered}
    </ButtonTabBase>
  );
}
